import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-base font-medium inline-block",
  "data-dusk": "radio-label"
}
const _hoisted_2 = { class: "flex flex-wrap gap-3" }
const _hoisted_3 = {
  key: 1,
  class: "pt-1 mt-2 text-sm font-medium text-danger-800 leading-4 border-t border-danger-700"
}

import { PropType } from 'vue';
import { BaseIcon } from '@/lib/components/Icon';
import BaseRadio from './BaseRadio.vue';

interface IRadioGroupOption {
  label: string;
  value: any;
  title?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: {
  icon: {
    type: String,
    default: null
  },
  iconHeight: {
    type: String,
    default: '25px'
  },
  label: {
    type: String,
    default: null
  },
  name: {
    type: String,
    default: null
  },
  options: {
    type: Array as PropType<string[] | IRadioGroupOption[]>,
    required: true
  },
  modelValue: {
    type: [String, Boolean],
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  error: {
    type: String,
    default: null
  },
  light: {
    type: Boolean,
    default: false
  },
  isOptional: {
    type: Boolean,
    default: false
  },
  labelPosition: {
    type: String,
    validator: (value: string) => ['left', 'right'].includes(value),
    default: 'right'
  }
},
  emits: ["update:modelValue", "change"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: any): void;
  (e: 'change', value: any): void
}), expose: any, slots: any, attrs: any }) {



const onUpdate = (value: any) => {
  emit('update:modelValue', value);
  emit('change', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    ((__props.icon && __props.icon.length) || (__props.label && __props.label.length))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([{ 'text-transparent bg-gray-200 rounded-lg': __props.loading }, "flex items-center mb-3"])
        }, [
          (__props.icon && __props.icon.length)
            ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                key: 0,
                name: __props.icon,
                height: __props.iconHeight,
                position: "left",
                class: _normalizeClass({ invisible: __props.loading })
              }, null, 8, ["name", "height", "class"]))
            : _createCommentVNode("", true),
          (__props.label && __props.label.length)
            ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
            : _createCommentVNode("", true),
          (__props.isOptional)
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: _normalizeClass([__props.loading ? 'text-transparent bg-gray-200 rounded-lg' : 'text-gray-500', "text-xs font-medium cursor-default capitalize ml-3 mt-1"])
              }, _toDisplayString(_ctx.$t('platform.common.optional')), 3))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createBlock(BaseRadio, {
          key: option.label ? option.label : option,
          "model-value": __props.modelValue,
          title: option.title,
          label: option.label ? option.label : option,
          value: option.label ? option.value : option,
          disabled: __props.disabled,
          loading: __props.loading,
          light: __props.light,
          name: __props.name,
          "label-position": __props.labelPosition,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (onUpdate($event)))
        }, null, 8, ["model-value", "title", "label", "value", "disabled", "loading", "light", "name", "label-position"]))
      }), 128))
    ]),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})